import { render, staticRenderFns } from "./PatentAnnuityWillPay.vue?vue&type=template&id=59f68821&"
import script from "./PatentAnnuityWillPay.vue?vue&type=script&lang=js&"
export * from "./PatentAnnuityWillPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports